import moment from 'moment'
import { DateRangeOperator, getDateRangeValues } from 'app/filter.utils'
import type { ContactJson } from 'app/types/entities'

const OPEN_LEAD_STATUSES: readonly string[] = [`Needs Action`, `In Progress`]

type ActiveLeadFields = Pick<ContactJson, `leadStatus` | `becameLeadDate` | `needsActionDate` | `patientStatus`>

/**
 * The `active-leads` queue's search terms, read off a contact already loaded. A table row
 * asks this rather than the server so its chip follows a Lead Status edit at once instead
 * of waiting on the index.
 */
export function isOnActiveLeads(contact: ActiveLeadFields, needsActionDateEnabled: boolean): boolean {
  const joinedAt = needsActionDateEnabled ? contact.needsActionDate : contact.becameLeadDate
  if (!joinedAt || !OPEN_LEAD_STATUSES.includes(contact.leadStatus ?? ``)) return false
  if (contact.patientStatus === `NonPatient`) return false
  const [from, to] = getDateRangeValues(DateRangeOperator.last_30_days)
  return moment(joinedAt).isBetween(from, to, undefined, `[]`)
}
